// Prebuilt Liquid snippets surfaced in the editor toolbar.
// Each snippet is raw Liquid; insertion goes through chipify so blocks
// render as a single non-editable chip per `{% ... %}` / `{{ ... }}` token.

export const LIQUID_SNIPPETS = [
  {
    id: "greeting-time",
    label: "Time-based greeting",
    description: "Good Morning / Afternoon / Evening based on recipient's local hour",
    body:
      `{% assign time_h = 'now' | date: "%H%M" | plus: 0 %}` +
      `{% if time_h < 1200 %}Good Morning {{firstName}},` +
      `{% elsif time_h < 1800 %}Good Afternoon {{firstName}},` +
      `{% else %}Good Evening {{firstName}},` +
      `{% endif %}`,
  },
  {
    id: "greeting-day",
    label: "Day-of-week greeting",
    description: "Different copy for Monday vs Friday",
    body:
      `{% assign handle = 'now' | date: '%A' %}` +
      `{% case handle %}` +
      `{% when 'Monday' %}Hope you're having a good start to the week.` +
      `{% when 'Friday' %}Happy Friday!` +
      `{% else %}Hope you're having a good week.` +
      `{% endcase %}`,
  },
  {
    id: "if-job-title",
    label: "Conditional by job title",
    description: "Branch on jobTitle value",
    body: `{% if jobTitle == "founder" %}As a founder, you know delegation matters.{% endif %}`,
  },
  {
    id: "default-fallback",
    label: "Variable with fallback",
    description: "Use {{firstName}} or fall back to 'there'",
    body: `{{ firstName | default: "there" }}`,
  },
  {
    id: "yesterday-date",
    label: "Yesterday's date",
    description: "Inserts yesterday's date as 'April 30, 2026'",
    body: `{{ 'now' | date: '%s' | minus: 86400 | date: '%B %d, %Y' }}`,
  },
  {
    id: "current-month",
    label: "Current month name",
    description: "e.g. 'May'",
    body: `{{ 'now' | date: '%B' }}`,
  },
];
